import React, { useCallback } from 'react'

import styled, { css } from 'styled-components'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { DoubleDropdown } from 'components/GeoPicker'
import { getLabel } from 'utils/parameters'
import styleguide from 'styleguide'
import Breadcrumbs from 'components/Breadcrumbs'
import QuickassCategoryPicker from '../QuickassCategoryPicker'
import Search from './Search'
import FilterView from '../FilterView'

const SearchWrapper = styled.div`
  display: flex;
`

export const Ribbon = styled.div`
  background-color: ${styleguide.color.blue};
  max-width: 100%;
  margin: 0 auto;
  padding: 8px 0;
`

const padding = css`
  ${({ withPaddingTop: p }) => (p ? `& > div:first-child { padding-top: 12px; }` : '')}
  ${({ withPaddingSideways: p }) =>
    p ? `@media (max-width: 980px) { padding-left: 16px; padding-right: 16px; }` : ''}
`

export const CenterContent = styled.div`
  max-width: 980px;
  margin: 0 auto;
  ${padding}
`

const StyledSearch = styled(Search)`
  min-width: 200px;
  flex: 8;
`

const DoubleDropdownWrapper = styled.div`
  width: 340px;
`

export const createSearch = (search, q) => {
  if (q) {
    return { ...search, q }
  }
  delete search.q
  return search
}

export const SearchHeaderResponsive = ({
  location,
  searchParamsActions,
  searchSubsetDescription,
  breadcrumbs,
  searchParametersDefinition,
  searchInputActions,
  cgParameterDefinition,
  geoPref,
  isFetching,
  filterQuery,
}) => {
  const search = queryString.parse(location.search)
  const haveCategory = Boolean(search && search.cg)
  const haveSearchQuery = Boolean(search && search.q)
  const showPlaceholder = searchSubsetDescription ? `Sök inom ${searchSubsetDescription}` : ''
  const showTypOfAnnonsFilter = haveCategory || haveSearchQuery

  const updateSearchParams = useCallback(
    (newSearchParams) => {
      searchParamsActions.select(
        {
          page: undefined,
          ...newSearchParams,
        },
        { updateListPathname: true },
      )
    },
    [searchParamsActions],
  )

  const onSecondLevelCategoryClick = (link) => {
    const { q, cg } = queryString.parse(link.split('?').pop())
    if (q && cg) {
      const cgLabel = getLabel(cgParameterDefinition, { cg })
      searchInputActions.updateHistory(q, { cg, cgLabel })
    }
  }

  return (
    <>
      <Ribbon>
        <CenterContent withPaddingSideways>
          <SearchWrapper>
            <StyledSearch
              key={`${queryString.stringify(search)}`}
              initialValue={search.q || ''}
              onSubmit={updateSearchParams}
              placeholder={haveCategory ? showPlaceholder : undefined}
            />
            <DoubleDropdownWrapper>
              <DoubleDropdown onChange={updateSearchParams} iisFetching={isFetching} />
            </DoubleDropdownWrapper>
          </SearchWrapper>
        </CenterContent>
      </Ribbon>
      <CenterContent withPaddingTop withPaddingSideways>
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          searchParametersDefinition={searchParametersDefinition}
          geoPref={geoPref}
          filterQuery={filterQuery}
        />
      </CenterContent>
      <CenterContent>
        <QuickassCategoryPicker onSecondLevelCategoryClick={onSecondLevelCategoryClick} />
        {showTypOfAnnonsFilter && <FilterView />}
      </CenterContent>
    </>
  )
}

SearchHeaderResponsive.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  searchParamsActions: PropTypes.shape({
    select: PropTypes.func.isRequired,
  }),
  searchInputActions: PropTypes.shape({
    updateHistory: PropTypes.func.isRequired,
  }),
  searchSubsetDescription: PropTypes.string,
  breadcrumbs: PropTypes.array,
  searchParametersDefinition: PropTypes.object,
  cgParameterDefinition: PropTypes.shape({}),
  geoPref: PropTypes.object,
  isFetching: PropTypes.bool,
  filterQuery: PropTypes.object,
}

export default withRouter(SearchHeaderResponsive)
